import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { MSEventDetailsPage } from "@/pages/(home)/(my-space)/events/event-details";
import { store } from "@/store";
import { mySpaceEventsApi } from "@/services/(my-space)/api.events";

// Lazy so the route file doesn't eagerly pull the tabs page (which imports
// nav-tabs.config) during config initialization — avoids a circular-import TDZ.
const MySpaceEventsPage = lazy(() =>
  import("@/pages/(home)/(my-space)/events").then((m) => ({
    default: m.MySpaceEventsPage,
  })),
);
const MsEventsListPage = lazy(
  () => import("@/pages/(home)/(my-space)/events/list"),
);

export const MS_DYNAMIC_EVENT_ID_KEY = "eventId";
export enum MS_EVENT_PATH_SEGMENTS {
  ROOT = "events",
  DETAILS = `:${MS_DYNAMIC_EVENT_ID_KEY}`,
}

export const myspaceEventRoutes: RouteObject = {
  path: MS_EVENT_PATH_SEGMENTS.ROOT,
  HydrateFallback: Spinner, // TO BE MOVED TO TOP LEVEL OF ROUTES
  handle: { breadcrumb: "Events" },
  children: [
    // ── Page-level tabs layout (single "List of Events" tab at the root) ────
    {
      Component: MySpaceEventsPage,
      handle: { flushContent: true },
      children: [{ index: true, Component: MsEventsListPage }], // /events
    },
    {
      path: MS_EVENT_PATH_SEGMENTS.DETAILS,
      children: [
        {
          index: true, // /events/12
          Component: MSEventDetailsPage,
          loader: async ({ params }) => {
            const eventId = params[MS_DYNAMIC_EVENT_ID_KEY]!;
            const result = await store.dispatch(mySpaceEventsApi.endpoints.msGetEventById.initiate({ eventId }));
            const name = result.data?.data?.event?.title ?? `Event #${eventId}`;
            return { breadcrumbLabel: name };
          },
          handle: {
            breadcrumb: (data: { breadcrumbLabel: string }) => data?.breadcrumbLabel ?? "Event Details",
          },
        },
      ],
    },
  ],
};

export const MS_EVENT_PATHS = Object.freeze({
  ROOT: addSlashes(MS_EVENT_PATH_SEGMENTS.ROOT),
  VIEW: (id: string | number) => addSlashes(MS_EVENT_PATH_SEGMENTS.ROOT, String(id)),
});
